import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isMenuOpen = false;

  constructor(public router: Router) {}

  ngOnInit(): void {}

  openMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
